'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagPfAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V5.33333H28V0Z", fill: "#E02639" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28.0002 14.6667H0.00016276L0 20H28L28.0002 14.6667Z",
          fill: "#DC2235"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28 5.33333H0L0.00016276 14.6667H28.0002L28 5.33333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M17.3335 6.66667H10.6668V10H17.3335V6.66667Z", fill: "#FFA135" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 8.66665H16L15.3333 9.99998H12.6667L12 8.66665Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.3333 6.66665H14.6667V8.6604C14.6667 9.03204 14.3574 9.33331 14 9.33331C13.6318 9.33331 13.3333 9.04793 13.3333 8.6604V6.66665ZM12 7.99998C12 7.99998 13 9.99998 14 9.99998C15 9.99998 16 7.99998 16 7.99998V9.33331C16 10.0697 15.4098 10.6666 14.6681 10.6666H13.3319C12.5963 10.6666 12 10.0748 12 9.33331V7.99998Z",
          fill: "#DF2034"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.3333 10.6666H10.6667V13.3333H17.3333V10.6666Z",
          fill: "#0B4BAD"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.6667 11.3333H17.3333V12H10.6667V11.3333Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagPfAsset = forwardRef(FlagPfAsset);

export { VpFlagPfAsset as default };
